import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import ReactPaginate from 'react-paginate';

import {
    Card,
    Row,
    Col,
    CardTitle,
    CardBody,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    FormText,
    Table
} from "reactstrap";


const HelperFlagMaster = () => {

    const navigate = useNavigate();
    const [helperFlagMasterTable, setHelperFlagMasterTable] = useState([]);
    const [totalPage, setTotalPage] = useState(); // Current page for pagination


    const onHandleSearchKeyItem = (e) => {
        const value = e.target.value; // Assuming you're trying to get the value from an input field
        getHelperFlagMasterData(1, 10, value)
    }

    const onHandleAddHelperFlagMaster = () => {
        navigate("/addhelperflag")
    }

    const onHandleEditHelperFlagMaster = (id) => {
        let findArrayData = helperFlagMasterTable.find(e => e.id === id)
        navigate('/addhelperflag', { state: { id: findArrayData?.id, helper_flag_name: findArrayData?.helper_flag_name } });
    }

    const getHelperFlagMasterData = async (page = 1, limit = 10, search = "") => {
        try {
            let config = {
                headers: {
                    'Content-Type': 'application/json', // Important for file upload//s
                    'accept': 'application/json'
                }
            };

            const response = await apiService.get(`api/HelperFlagMaster/allHelperFlag?pageNo=${page}&limit=${limit}&searchKey=${search}`, config)
            if (response.response && response.response.data.errors) {
                toast.success(response.response?.data?.errors);
            }

            if (response.status === true) {
                console.log(response.categoryMasterDetailData)
                setHelperFlagMasterTable(response.helperFlagMasterData)
                setTotalPage(response.totalPages)
                // toast.success(response.message);
            }
            else {
                toast.success(response.message);
            }
        } catch (error) {
            console.log(error)
             toast.error(`SomeThing went wrong!!`);
        }
    };

    useEffect(() => {
        getHelperFlagMasterData();
    }, [!helperFlagMasterTable]);

    const handlePageClick = (data) => {
        getHelperFlagMasterData(data.selected + 1)
    };

    const onHandleDeleteHelperFlagMaster = async (id) => {

        const isDeleteConfirmed = window.confirm('Are you sure you want to delete this item?');
        if (isDeleteConfirmed) {
            try {
                let config = {
                    headers: {
                        'Content-Type': 'application/json', // Important for file upload//s
                        'accept': 'application/json'
                    }
                };

                const response = await apiService.delete(`api/HelperFlagMaster/delete?helperFlagId=${id}`, config)
                if (response.response && response.response.data.errors) {
                    toast.success(response.response?.data?.errors);
                }

                if (response.status === true) {
                    toast.success(response.message);
                    getHelperFlagMasterData()
                }
                else {
                    toast.success(response.message);
                }
            } catch (error) {
                console.log(error)
                 toast.error(`SomeThing went wrong!!`);
            }
        } else {
            console.log('Deletion canceled.');
        }
    };



    return (
        <>
            <Col lg="12">
                <Card className='bg-white pd-10 card-box mb-30'>
                    <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <i className="bi bi-card-text mr-2"></i>
                            Helper Flag Details
                        </div>

                        <Row className="align-items-center" style={{ marginRight: '10px', width: '300px' }}>
                            <Input   id="search" name="search" placeholder="Search..." type="text" onChange={(e) => { onHandleSearchKeyItem(e) }} />
                        </Row>

                        <Button color="primary" size="bg" onClick={onHandleAddHelperFlagMaster}>Add HelperFlagMaster</Button>
                    </CardTitle>

                    <CardBody className="">
                        <Table hover striped responsive>
                            <thead>
                                <tr>
                                     <th>S. no.</th>
                                    <th>Flag Name</th>


                                    <th>Edit</th>
                                    <th>Delete</th>

                                </tr>
                            </thead>
                            <tbody>
                                {helperFlagMasterTable.map((item, index) => (
                                    <tr key={index}>
                                        <th scope="row">{index + 1}</th>
                                        <td>{item.helper_flag_name}</td>
                                        <td>
                                            <Button color="success" size="bg" onClick={() => onHandleEditHelperFlagMaster(item.id)}>
                                           <i className="bi bi-pencil mr-1"></i>
                                            </Button>
                                        </td>
                                        <td>
                                            <Button color="danger" size="bg" onClick={() => onHandleDeleteHelperFlagMaster(item.id)}>
                                            <i className="fas fa-trash"></i>
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </CardBody>
                    
                    <CardBody>
                        {/* <ReactPaginate
                            previousLabel={'Previous'}
                            nextLabel={'Next'}
                            breakLabel={'...'}
                            breakClassName={'break-me'}
                            pageCount={totalPage}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={handlePageClick}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        /> */}

                        <ReactPaginate
                            previousLabel={'Previous'}
                            nextLabel={'Next'}
                            breakLabel={'...'}
                            pageCount={totalPage} // still 4000
                            marginPagesDisplayed={1} // 1 page at start & end
                            pageRangeDisplayed={2}  // visible range around selected page
                            onPageChange={handlePageClick}
                            containerClassName={'pagination'}
                            activeClassName={'active'}

                            pageClassName={'page-item'}
                            pageLinkClassName={'page-link'}
                            previousClassName={'page-item'}
                            nextClassName={'page-item'}
                            previousLinkClassName={'page-link'}
                            nextLinkClassName={'page-link'}
                            breakClassName={'page-item'}
                            breakLinkClassName={'page-link'}
                        />
                    </CardBody>
                </Card>
            </Col>
        </>
    )
}

export default HelperFlagMaster